module.exports = __webpack_public_path__ + "fonts/Typo_Round_Light_Italic_Demo.dc214502.otf";